import { east8TimestampToDateTime } from '@/helper'
import { TradeRecord } from '@kulee/tga-sdk/types/types/wallet'
import React from 'react'
import { useTranslation } from 'react-i18next'

const TradeRecordItem: React.FC<PropType> = ({ item }) => {
  const { t } = useTranslation('wallet')

  const { amount, businessCode, type, createTime } = item

  const amountComp = type === 1 ? <span className="text-primary-dark">+ {amount}</span> : <span>- {amount}</span>

  return (
    <div className="flex items-center">
      <div className="flex-grow">
        <p className="text-base font-semibold">{t(`bussiness.${businessCode.toLowerCase()}`)}</p>
        <p className="text-gray-400">{east8TimestampToDateTime(createTime)}</p>
      </div>
      <div className="text-lg font-semibold">{amountComp}</div>
    </div>
  )
}

interface PropType {
  item: TradeRecord
}

export default TradeRecordItem
